femcare.audioPlatform.spotify = {

    init: function () {
        var $podcasts = $('.podcast-embed--spotify');

        if ($podcasts.length) {
            $podcasts.each(function (index, element) {
                var $container = $(element);
                var source = $container.attr('data-spotify-source');
                var embedPodcastRoute = 'https://open.spotify.com/embed-podcast/';

                var url = null;
                if (source.indexOf(embedPodcastRoute) === 0) {
                    url = source;
                } else {
                    // Expected podcast source values
                    // https://open.spotify.com/show/0DodjCkSO2sTNG1CCgBPn6
                    // https://open.spotify.com/episode/3irbZfXyHrs85F9hpccmOI

                    var trackIdentifier = (/https:\/\/open.spotify.com\/(.*)/).exec(source)[1];
                    url = embedPodcastRoute + trackIdentifier;
                }

                var $iframe = $('<iframe src="' + url + '" width="100%" height="166" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>')
                $container.html($iframe);
            });
        }
    }
};
